module.exports = __webpack_public_path__ + "static/media/car-location-blue.e15e5bd9.svg";